import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MngAdminComponent } from './mng-admin.component';
import { AuthGuard } from 'src/app/config/auth.guard';
import { ProfileComponent } from './profile/profile.component';
import { UsersComponent } from './users/users.component';
import { SettingsComponent } from './settings/settings.component';


const routes: Routes = [
    {
        path: 'mng-admin',
        component: MngAdminComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'profile',
                component: ProfileComponent,
            },
            {
                path: 'users',
                component: UsersComponent,
            },
            {
                path: 'setting',
                component: SettingsComponent,
            },
            {
                path: '**',
                redirectTo: 'profile'
            }


        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class MngAdminRoutingModule { }